import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CardList from "./CardsList";
import * as tournamentThunks from "../../../../redux/thunks/tournamentThunks";
import tournamentActions from "../../../../redux/reducers/tournamentReducer/tournamentActions";

const CardsListContainer = ({
  tournamentEditing,
  typeCard,
  organizerId,
  tournamentId,
  loading,
  redCards,
  yellowCards,
  loadTournamentRedCards,
  loadTournamentYellowCards,
  clearTournamentRedCards,
  clearTournamentYellowCards,
  show,
}) => {
  const DEFAULT_PAGE_SIZE = 25;
  const DEFAULT_PAGE = 0;

  useEffect(() => {
    clearTournamentRedCards();
    clearTournamentYellowCards();

    if (tournamentEditing) {
      typeCard === "RedCard" &&
        loadTournamentRedCards(
          DEFAULT_PAGE,
          DEFAULT_PAGE_SIZE,
          organizerId,
          tournamentId
        );
      typeCard === "YellowCard" &&
        loadTournamentYellowCards(
          DEFAULT_PAGE,
          DEFAULT_PAGE_SIZE,
          organizerId,
          tournamentId
        );
    }
  }, []);

  const onRefreshUsers = (page, pageSize) => {
    if (typeCard === "RedCard") {
      clearTournamentRedCards();
      loadTournamentRedCards(page, pageSize, organizerId, tournamentId);
    } else {
      clearTournamentYellowCards();
      loadTournamentYellowCards(page, pageSize, organizerId, tournamentId);
    }
  };

  return (
    show && (
      <CardList
        typeCard={typeCard}
        cards={typeCard === "RedCard" ? redCards : yellowCards}
        loadingFetchRedCards={loading.tournament.loadTournamentRedCards}
        organizerId={organizerId}
        tournamentId={tournamentId}
        defaultPage={DEFAULT_PAGE}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        onRefreshUsers={onRefreshUsers}
      />
    )
  );
};

const mapState = (state) => ({
  loading: state.loading,
  redCards: state.tournament.redCards,
  yellowCards: state.tournament.yellowCards,
});

const mapDispatch = (dispatch) => ({
  loadTournamentRedCards: (page, pageSize, organizerId, tournamentId) =>
    dispatch(
      tournamentThunks.loadTournamentRedCards(
        page,
        pageSize,
        organizerId,
        tournamentId
      )
    ),
  clearTournamentRedCards: () =>
    dispatch(tournamentActions.clearTournamentRedCards()),
  loadTournamentYellowCards: (page, pageSize, organizerId, tournamentId) =>
    dispatch(
      tournamentThunks.loadTournamentYellowCards(
        page,
        pageSize,
        organizerId,
        tournamentId
      )
    ),
  clearTournamentYellowCards: () =>
    dispatch(tournamentActions.clearTournamentYellowCards()),
});

export default withRouter(connect(mapState, mapDispatch)(CardsListContainer));
